import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import styled from "styled-components";

import NewGame from "./features/newGame/NewGame";
import Battle from './features/battle/Battle';

const StyledApp = styled.div`
    font-family: 'Nunito Sans', 'Open Sans', sans-serif;;
    color: darkslategray;
`;

const App = () => {
    return (
        <BrowserRouter>
            <StyledApp>
                <Routes>
                    <Route path="/" element={<NewGame />} />
                    <Route path="/game" element={<Battle />}/>
                </Routes>
            </StyledApp>
        </BrowserRouter>
    );
}

export default App;